// extracted by mini-css-extract-plugin
export default {"overlay":"IC-z","bodyOpen":"JC-z","content":"KC-z","header":"LC-z","close":"MC-z","closeNoHeading":"NC-z"};